import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const PNRTransactionReport = ({ startDate, endDate, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/pnr/TransactionDateReport?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Use the data directly
        const rows = response.data.data.map((row, idx) => ({
          id: idx + 1,
          transaction_date: row.transaction_date,
          New: Number(row["New"]),
          "New + Modified": Number(row["New + Modified"]),
          "New + Cancelled": Number(row["New + Cancelled"]),
          "New, Modified + Cancelled": Number(row["New, Modified + Cancelled"]),
          total_pnrs: Number(row.total_pnrs),
          actions: Number(row.actions),
          new_tickets: Number(row.new_tickets),
          active: Number(row.active),
          pending: Number(row.pending),
          resolved: Number(row.resolved),
        }));

        setData(rows);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  const columns = [
    { field: "transaction_date", headerName: "Transaction Date", flex: 1 },
    { field: "New", headerName: "New", flex: 1, type: "number" },
    {
      field: "New + Modified",
      headerName: "New + Modified",
      flex: 1,
      type: "number",
    },
    {
      field: "New + Cancelled",
      headerName: "New + Cancelled",
      flex: 1,
      type: "number",
    },
    {
      field: "New, Modified + Cancelled",
      headerName: "New, Modified + Cancelled",
      flex: 1,
      type: "number",
    },
    { field: "total_pnrs", headerName: "Total PNRs", flex: 1, type: "number" },
    { field: "actions", headerName: "Actions", flex: 1, type: "number" },
    {
      field: "new_tickets",
      headerName: "New Tickets",
      flex: 1,
      type: "number",
    },
    { field: "active", headerName: "Active", flex: 1, type: "number" },
    { field: "pending", headerName: "Pending", flex: 1, type: "number" },
    { field: "resolved", headerName: "Resolved", flex: 1, type: "number" },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.length === 0) return <h3>No Data Available</h3>;

  return (
    <Box sx={{ height: 600, width: "100%", marginTop: 2 }}>
      <DataGridPremium
        rows={data}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        slots={{ toolbar: GridToolbar }}
        pageSizeOptions={[5, 10, 15, 20]}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
};

export default PNRTransactionReport;
